import React from 'react';
import logo from '../assets/logos/olympic-logo.svg';
import { useSiteChrome } from './useSiteChrome';

/**
 * The slim site header for the apps (Titan, My Booking): the logo (to the website), and the call centre's number and
 * today's hours (worked out by the app for each page, from the home page's opening times). `children` go before the number - an app's own controls (Titan's "Change search").
 * The content is the page's window.siteChrome (written by the app's layout), or `chrome` when given.
 *
 * Below lg it follows the mobile comp like the website's header: the number and hours move up into a 53px utility bar
 * (number bold on the left, hours on the right, 17.33px), and the header is 101px with the 69px logo, 23px margins.
 */
export function SiteHeader({ chrome: given, children }) {
    const chrome = useSiteChrome(given);
    const header = chrome?.header || {};
    const phone = header.phoneNumber;
    const tel = phone ? `tel:${phone.replace(/\s+/g, '')}` : null;
    return (
        <>
            {phone || header.openingHours ? (
                <div className="oly-utilbar lg:hidden">
                    <div className="oly-container flex min-h-[3.3125rem] items-center justify-between gap-4 px-[1.4375rem] text-[1.08312rem]">
                        {phone ? (
                            <a href={tel} className="font-bold text-white hover:underline">
                                {phone}
                            </a>
                        ) : (
                            <span />
                        )}
                        {header.openingHours ? <span className="font-medium">{header.openingHours}</span> : null}
                    </div>
                </div>
            ) : null}
            <header className="oly-header" role="banner">
                <div className="oly-container flex items-center justify-between gap-4 py-3 max-lg:min-h-[6.3125rem] max-lg:px-[1.4375rem]">
                    <a href={header.homeUrl || '/'} className="shrink-0" aria-label="Olympic Holidays home">
                        <img src={logo} alt="Olympic Holidays" className="h-[4.3125rem] w-auto lg:h-12" width="143" height="56" />
                    </a>
                    <div className="flex items-center gap-3 sm:gap-6">
                        {children}
                        {phone || header.openingHours ? (
                            <div className="hidden text-right leading-tight lg:block">
                                {phone ? (
                                    <a href={tel} className="inline-flex items-center gap-2 text-lg font-bold text-navy-700 hover:underline">
                                        <svg className="size-4 shrink-0" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.4.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1l-2.3 2.2z" /></svg>
                                        <span>{phone}</span>
                                    </a>
                                ) : null}
                                {header.openingHours ? <p className="mt-0.5 text-xs text-ink-soft">{header.openingHours}</p> : null}
                            </div>
                        ) : null}
                    </div>
                </div>
            </header>
        </>
    );
}

export default SiteHeader;
